import Component from './MSIFields';

export default Component;
